import type { Option } from '../CriteriaPanel/types';

/**
 * ZET-4463: the chips a user has picked in a Domains/Tags box are shown in the same order as the
 * dropdown they came from. The stored value is the domain name (the DomainID only appears in the
 * label), so the order comes from the options list, which is already sorted by DomainID in the
 * chosen direction with tags first. Values not found in the options keep their place at the end.
 */
export function sortDomainValues(values: string[] | null | undefined, options: Option[] | undefined): string[] {
  const list = values ?? [];
  if (!options || options.length === 0) return list;
  const position = new Map(options.map((o, i) => [o.value, i]));
  const rank = (v: string) => position.get(v) ?? Number.POSITIVE_INFINITY;
  return [...list].sort((a, b) => rank(a) - rank(b));
}
